import type { ComponentProps } from 'react';
import { DatePicker as AntdDatePicker, type DatePickerProps } from 'antd';
import type { Dayjs } from 'dayjs';

import { renderCalendarCell } from './calendar_cell_render';

/**
 * antds DatePicker mit hervorgehobenen Wochenenden und Feiertagen (#206).
 * Drop-in-Ersatz: `import { DatePicker } from '@/components/date_picker/date_picker'`
 * statt aus `antd`, inklusive `DatePicker.RangePicker`. Ein eigenes
 * `cellRender` des Aufrufers hat weiterhin Vorrang.
 *
 * Neue Kalender bitte immer hierüber bauen, sonst fehlt die Markierung.
 */
function DatePickerWithHolidays<ValueType = Dayjs, IsMultiple extends boolean = false>(
  props: DatePickerProps<ValueType, IsMultiple>,
) {
  return <AntdDatePicker<ValueType, IsMultiple> cellRender={renderCalendarCell} {...props} />;
}

function RangePicker(props: ComponentProps<typeof AntdDatePicker.RangePicker>) {
  return <AntdDatePicker.RangePicker cellRender={renderCalendarCell} {...props} />;
}

export const DatePicker = Object.assign(DatePickerWithHolidays, { RangePicker });
